export default "__VITE_ASSET__CqPaGvkl__"